import React, { useRef, useEffect } from 'react';

export default function AutoScrollContainer({ children, className }) {
  const ref = useRef(null);
  
  useEffect(() => {
    if (ref.current) {
      ref.current.scrollTop = ref.current.scrollHeight;
    }
  }, []); // Run once on mount

  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  );
}